import React, { useEffect, useState } from "react";
import SideBar from "./SideBar";
import Header from "./Header";
import { SlHome, SlArrowRight } from "react-icons/sl";
import { useLocation } from "react-router-dom";
import { getYouMayLikeHeaderDetailsAPI, youMayLikeSectionAPI } from "../../serverApi/server";
import { MdDeleteOutline } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { AiOutlineCheckCircle } from "react-icons/ai";
import Select from "react-select";
import { MultiSelect } from 'primereact/multiselect';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';


const YouMayLike = () => {
  const location = useLocation();
  const headerMenus = location.state || [];
  const [successMessage, setSuccessMessage] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(
    headerMenus.find((menu) => menu.additional_name === "memorial_funeral")
      ?.id || ""
  );
  const [categoryList, setCategoryList] = useState([]);
  const [subMenuList, setSubMenuList] = useState("");
  const [fieldType, setFieldType] = useState([]);
  const [editOpen, setEditOpen] = useState(false);
  const [descriptionTable, setDescriptionTable] = useState({});

  const toggleEdit = () => setEditOpen(!editOpen);

  const fetchCategorySubMenus = async (categoryId) => {
    try {
      const response = await getYouMayLikeHeaderDetailsAPI(categoryId);
      const categories = response.data.categories_serializer;
      setCategoryList(categories);
      setSubMenuList(
        categories.find((menu) => menu.additional_name === "bookmarks")?.id || ""
      );
    } catch (error) {
      console.error("Error fetching sub-menus:", error);
    }
  };

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => setSuccessMessage(''), 6000);
      return () => clearTimeout(timer);
    }
  }, [successMessage]);

  useEffect(() => {
    if (selectedCategory) {
      fetchCategorySubMenus(selectedCategory);
    }
  }, [selectedCategory]);

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
  };

  const [selectedCategories, setSelectedCategories] = useState([]);

  const selectedCategoriesList = async (multiSelectCategoryId, seletedCategoryId) => {
    setSelectedCategories(multiSelectCategoryId)
    setCategoryList(categoryList.map(category => 
      category.id === seletedCategoryId ? { ...category, you_may_like_id: multiSelectCategoryId } : category
    ));
    const youMayLikeSectionAPIResponse = await youMayLikeSectionAPI(selectedCategory, seletedCategoryId, multiSelectCategoryId)
  }


  return (
    <div className="flex w-full h-screen">
      <div className="fixed h-full custom-scroll">
        <SideBar />
      </div>

      <div className="ml-64 flex-1">
        <Header />
        <section className="bg-[#F5F7FD] px-7 py-6">
          <div className="flex items-center justify-between">
            <div className="text-blue-950 flex items-center gap-6">
              <h1 className="pr-6 text-2xl font-medium border-r">
                Admin Users
              </h1>
              <div className="flex text-sm items-center gap-3">
                <button>
                  <SlHome />
                </button>
                <SlArrowRight />
                <button>You May Like</button>
              </div>
            </div>
          </div>

          {editOpen && (
            <div
              className="overflow-y-auto fixed inset-0 h-full z-50 flex items-center justify-center bg-black bg-opacity-50"
              aria-hidden="true"
            >
              <div className="bg-white rounded-lg w-11/12 max-w-md max-h-[90vh] overflow-y-auto animate-slide-down">
                <div className="flex justify-between items-center p-4 border-b">
                  <h5 className="text-lg font-medium">
                    Edit Description
                  </h5>
                  <button
                    type="button"
                    className="text-gray-600 text-3xl hover:text-gray-900"
                    onClick={toggleEdit}
                  >
                    &times;
                  </button>
                </div>
                <div className="p-4">
                  <form>
                    <div className="mb-4">
                      <label
                        htmlFor="subCategory"
                        className="block text-sm text-gray-700"
                      >
                        Edit the field Description
                      </label>
                      <textarea
                        name="textArea"
                        value={descriptionTable.description || ""}
                        onChange={(e) =>
                          setDescriptionTable((prevState) => ({
                            ...prevState,
                            description: e.target.value,
                          }))
                        }
                        placeholder="Enter text here"
                        className="h-[150px] mt-2 block w-full rounded-md border-2 px-3 py-2 focus:outline-none shadow-sm resize-none"
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}

          <section className="px-3 md:px-4 bg-white mt-10 py-4 rounded-lg shadow-[0px_0px_15px_0px_rgba(0,0,0,0.1)]">
            <div className="flex items-center gap-2">
              <div className="flex text-sm items-center gap-1 font-light">
                <p className="text-neutral-700">Filter by Category:</p>
                <select
                  className="focus:outline-none focus:border-blue-300 border rounded px-1 py-1"
                  onChange={handleCategoryChange}
                  value={selectedCategory}
                >
                  {headerMenus.map((menu) => (
                    <option key={menu.id} value={menu.id}>
                      {menu.menu}
                    </option>
                  ))}
                </select>

                {/* <select
                  className="focus:outline-none focus:border-blue-300 border rounded px-1 py-1"
                  onChange={handleSubMenuListChange}
                  value={subMenuList}
                >
                  {categoryList.map((menu) => (
                    <option key={menu.id} value={menu.id}>
                      {menu.category}
                    </option>
                  ))}
                </select> */}
                
              </div>
            </div>
            {successMessage && (
              <div className="mt-4 bg-green-100 text-green-800 p-4 flex items-center justify-between rounded">
                <div className="flex items-center gap-2">
                  <AiOutlineCheckCircle className="text-2xl" />
                  <span>{successMessage}</span>
                </div>
              </div>
            )}

            <div className="overflow-x-auto">
              <table
                className="min-w-full bg-white mt-8"
                style={{ borderCollapse: "separate", borderSpacing: "2px" }}
              >
                <thead>
                  <tr>
                    <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400 flex items-center justify-center space-x-2">
                      CATEGORY NAMES
                    </th>
                    <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400 ">
                      SELECTED CATEGORIES
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {categoryList.length > 0 ? (
                    categoryList.map((categoryData) => (
                        <tr key={categoryData.id}>
                            <td className="px-5 py-4 border border-[#48ABF7]">
                            {categoryData.category}
                            </td>

                            {/* <td className="px-5 py-4 border border-[#48ABF7]">
                                <select
                                    className="focus:outline-none focus:border-blue-300 border rounded px-1 py-1"
                                    onChange={handleSubMenuListChange}
                                    value={subMenuList}
                                    >
                                    {categoryList.map((menu) => (
                                        <option key={menu.id} value={menu.id}>
                                        {menu.category}
                                        </option>
                                    ))}
                                </select>
                            </td> */}


                          <td className="px-5 py-4 border border-[#48ABF7]">
                            <div className="card flex justify-content-center">
                              <MultiSelect 
                                style={{ border: "1px solid #d1d5db", padding: "10px" }} 
                                value={categoryData.you_may_like_id} 
                                onChange={(e) => selectedCategoriesList(e.value, categoryData.id)} 
                                options={categoryList.map(category => ({
                                  value: category.id,
                                  label: category.category
                                }))} 
                                optionLabel="label"
                                display="chip"
                                placeholder="Select Categories" 
                                maxSelectedLabels={3} 
                                className="w-full md:w-20rem" 
                              />
                            </div>
                          </td>



                        </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center py-4">
                        No fields available.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

            </div>
          </section>
        </section>
      </div>
    </div>
  );
};

export default YouMayLike;
